import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import TextField from '../../../shared/form-elements/textarea';

import ModalBox from '../../../shared/modal';

const formPropTypes  = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	isEditMode: PropTypes.bool
};

const Form = props => (
	<div className="canned-reply__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.formSubmit(data))}>
			<div className="ui-form__element">
				<Field name="title" placeholder={props.intl('Title')} component={InputField} />
			</div>

			<div className="ui-form__element">
				<Field name="text" placeholder={props.intl('Text')} component={TextField} />
			</div>

			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">
					{props.intl(props.isEditMode ? 'Edit' : 'Save')}
				</button>
			</div>
		</form>
	</div>
);

Form.propTypes = formPropTypes;

const mainPropTypes = {
	intl: PropTypes.func,
	shouldShowForm: PropTypes.bool,
	closeForm: PropTypes.func
};

const Main = props => (
	<ModalBox
		title={props.intl('Quick reply')}
		body={Form(props)}
		isOpen={props.shouldShowForm}
		onClose={props.closeForm}
		className="create-threads-modal"
	/>
);

Main.propTypes = mainPropTypes;

export default reduxForm({})(Main);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/canned-reply-form/main.js